import React, { useContext } from 'react';
import { PageStateContext } from '../../services';

const enableChatTag = 'chat:enabled';

export const LiveChat = (): JSX.Element => {
  const { page, environment } = useContext(PageStateContext);
  const chatIsEnabled = page?.tag_list?.includes(enableChatTag);

  const scriptUrl = environment.livechatScriptUrl;
  const scriptId = environment.livechatScriptId;
  const buttonId = environment.livechatButtonId;

  if (!chatIsEnabled || !scriptUrl || !scriptId || !buttonId) {
    return null;
  }

  return (
    <roche-livechat-banner script-url={scriptUrl} script-id={scriptId} button-id={buttonId} />
  );
};
